import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-shrink-0">
            <div className="w-48 md:w-56 aspect-[9/16] rounded-2xl overflow-hidden bg-background-200 border-4 border-background-200 shadow-lg">
              <img
                src={appData.image}
                alt="6789影院移动端观影体验"
                className="w-full h-full object-cover"
                onError={(e) => {
                  const target = e.currentTarget;
                  target.style.display = 'none';
                  if (target.parentElement) target.parentElement.style.display = 'none';
                }}
              />
            </div>
          </div>

          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
              移动观影
            </h2>
            <p className="text-base text-foreground-600 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              {appData.description}
            </p>

            <div className="grid grid-cols-2 gap-3 max-w-md mx-auto lg:mx-0 mb-6">
              {appData.features.map((f, idx) => (
                <div
                  key={idx}
                  className="flex items-center gap-2 p-3 rounded-lg bg-background-100 border border-background-200/70"
                >
                  <div className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 flex-shrink-0">
                    <i className="ri-check-line text-sm"></i>
                  </div>
                  <span className="text-xs font-medium text-foreground-700 whitespace-nowrap">{f}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <span className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium cursor-default">
                <i className="ri-apple-line text-lg"></i>
                iOS Safari 打开即用
              </span>
              <span className="whitespace-nowrap inline-flex items-center gap-2 px-5 py-2.5 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium cursor-default">
                <i className="ri-android-line text-lg"></i>
                Chrome 浏览器
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}